import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { dcbNamesActions, searchTableActions } from '../../actions'
import CrudHeader from '../../components/CrudHeader'
import Typography from '@material-ui/core/Typography'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class NamesDcb extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newNameDcb, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Nomes-DCB'}
          classes={classes}
          newResource={newNameDcb}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'nomesDcb'}
        />
        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.namesDcb.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(dcbNamesActions.openModal())
    },
    closeModal: () => {
      dispatch(dcbNamesActions.closeModal())
    },
    newNameDcb: nameDcb => {
      dispatch(dcbNamesActions.newFormNameDcb(nameDcb))
    },
    resetState: () => {
      dispatch(dcbNamesActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(NamesDcb))



// WEBPACK FOOTER //
// ./src/containers/DcbNames/index.js